<script>
import i18n from '@/modules/i18n';

export default {
  name: 'RequirePlan',
  props: {
    plan: [Array, String],
    label: {
      type: String,
      default: i18n.t('Upgrade')
    }
  },
  computed: {
    hasPlan() {
      const plan = Array.isArray(this.plan) ? this.plan : [this.plan];
      return plan.includes(this.$store.state.user.account.plan);
    }
  }
};
</script>

<template>
  <span v-if="!hasPlan" class="require-plan">
    <!-- Users who can manage billing see a tooltip and a link -->
    <el-tooltip
      v-if="$store.state.user.canManageBilling"
      :content="$t('Please upgrade your account to unlock this feature.')"
      placement="top"
    >
      <router-link :to="{ name: 'Billing' }">
        <el-tag size="mini">
          <i class="el-icon-fa-lock" />
          {{ label }}
        </el-tag>
      </router-link>
    </el-tooltip>

    <!-- Users who can't manage billing just see a locked tag -->
    <el-tag v-else size="mini">
      <i class="el-icon-fa-lock" />
      {{ label }}
    </el-tag>
  </span>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.require-plan {
  i {
    font-weight: bold;
  }

  .el-tag {
    font-weight: bold;
    font-size: 0.65rem;
    border-color: $--color-success;
    background-color: $--color-success;
    color: $--color-white;
    transform: translateY(-0.1rem);
  }

  &:not(:first-child) {
    margin-left: 0.25rem;
  }
}
</style>
